<template>
    <div class="card-container">
        <div :class="'card '  + (item.disabled?' disabled':'') + (item.active?' active':'')"
          v-for="item,idx in list"
          @click="select(item.title)"
        >
            <img :src="item.icon" />
            <div class="title">{{ item.title }}</div>
            <div class="detail">{{ item.detail }}</div>

        </div>
    </div>
</template>

<script>
import help_img from '~pic/help.png';
import {msgbox} from '~js/smallarAlert.esm.js';

import pic1 from '~pic/theory/流沙入海.jpg'
import pic2 from '~pic/theory/乳腺癌诊断.jpg'
import pic3 from '~pic/theory/次品追责.jpg'
import pic4 from '~pic/theory/核酸检测.jpeg'
import pic5 from '~pic/theory/HIV检测.jpg'
import pic6 from '~pic/theory/特征分类.jpg'
import pic7 from '~pic/theory/自定义.png'



export default {
    name:'BayesCase',
    props:{
        // title:String,
        help_msg:String,
        style_str:String,
    },
    data(){
        return {
            title:'帮助',
            list:[
                {icon:pic1,title:'流沙入海',disabled:false,active:false,detail:'现在有一片海域，只有黄河、长江、珠江、黑龙江等河流汇入。你知道这片海里的一粒沙子究竟来自哪条河吗？'},
                {icon:pic2,title:'乳腺癌诊断',disabled:false,active:false,detail:'正常人也有可能被误判为乳腺癌，你知道一个被诊断为乳腺癌的人真正患乳腺癌的概率是多少吗?'},
                {icon:pic3,title:'次品追责',disabled:false,active:false,detail:'甲乙两个工厂生产同一批次的产品，两个工厂都有可能生产次品。你知道某个次品来自甲工厂的概率是多少吗?'},
                {icon:pic4,title:'核酸检测',disabled:false,active:false,detail:'正常人的核酸检测结果也可能出现阳性，你知道一个核酸检测结果阳性的人其为新冠患者的概率是多少吗?'},
                {icon:pic5,title:'HIV检测',disabled:false,active:false,detail:'正常人的HIV病毒检测结果也可能出现阳性，你知道一个HIV病毒检测结果阳性的人其为艾滋病患者的概率是多少吗？'},
                {icon:pic6,title:'特征分类',disabled:false,active:false,detail:'男性和女性各有一定的概率其食指长于无名指。你知道一个食指长于无名指的人是男性的概率是多少吗？'},
                {icon:pic7,title:'自定义',disabled:false,active:false,detail:'尝试自己设计一个运用了贝叶斯原理进行计算的情境案例。'},
            ]
        }
    },
    mounted() {
         console.log('CaseGuide mounted')
    },
    methods:{
        select(name){
            console.log('select',name);
            this.$emit('select_case',name);
        },
        set_disabled(arr,val=true){
            if(!Array.isArray(arr)){
                arr = [arr];
            };
            // if(val==undefined)val = true;
            const that = this;
           arr.forEach((v,idx)=>{
                let card = that.list[v]??that.list.find(c=>c.title==v);
                if(card){
                    card.disabled = val;
                }else{
                    console.warn('bad list idx set ',arr);
                }
           })
        }
    }

}

</script>

<style scoped>
.card-container{
    width:100%;
    padding:1em 3em;
    box-sizing:border-box;
    z-index:2;
    display:flex;
    flex-wrap:wrap;
    justify-content:center;
    background-color:rgb(239,239,239);
}

.card{
    width:221px;
    height:290px;
    /* border:1px solid darkgray; */
    border-radius:8px;
    margin:1em;
    display:inline-flex;
    flex-direction:column;
    text-align:center;
    overflow:hidden;
    cursor:pointer;
    transition:all 0.5s;
    box-shadow:1px 1px 2px rgb(209, 209, 209),2px 2px 4px rgb(170, 170, 170),-1px -1px 2px rgb(233, 231, 231);
}

.card.disabled{
    filter:blur(1.2px);
    pointer-events:none;
}

.card:hover img{
    transform:scale(1.2);
    transition:all 0.5s;
    
}
.card:hover,.card.active{
    box-shadow:2px 2px 15px black;
    text-shadow:1px 1px darkgray;
}
.card img{
    width:100%;
    height:30%;
    transform:scale(1.0);
    transition:all 0.5s;
    border-radius:5px;
}

.card .title{
    font-size:25px;
    font-weight:bolder;
    font-family:auto;
    margin:0.5em;
}
.card .detail{
    font-family:auto;
    text-indent:2em;
    text-align:left;
    padding:0px 10px;
    line-height:1.7;
    transform:scale(0.8,1);
    letter-spacing:1.5px;

}

</style>